<template>
  <div id="payment-group-list" class="data-list-container">
    <data-view-sidebar
      :isSidebarActive="addNewDataSidebar"
      @closeSidebar="toggleDataSidebar"
      :data="sidebarData"
    />

    <vs-table ref="table" pagination :max-items="itemsPerPage" search :data="productData">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- ADD NEW -->
          <!-- <div
            class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
            @click="addNewData"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
            <span class="ml-2 text-base text-primary">Yeni Ürün Ekle</span>
          </div> -->
        </div>

        <!-- ITEMS PER PAGE -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div
            v-if="products.length > itemsPerPage"
            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium"
          >
            <span
              class="mr-2"
            >{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ products.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : products.length }} / {{ products.length }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
          </div>
          <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
          <vs-dropdown-menu>
            <vs-dropdown-item @click="itemsPerPage=4">
              <span>4</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=15">
              <span>15</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th>{{ $t("Table.PaymentGroup.Url") }}</vs-th>
        <vs-th sort-key="ProductTitle">{{ $t("Table.PaymentGroup.ProductTitle") }}</vs-th>  
        <vs-th sort-key="IsActive">{{ $t("Table.PaymentGroup.State") }}</vs-th>
        <vs-th>{{ $t("Table.PaymentGroup.Actions") }}</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
          <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
            <vs-td width="50">
              <a
                class="font-medium"
                v-clipboard:copy="generateUrl(tr.InvoiceSettingKey)"
                v-clipboard:success="onCopy"
              >Kopyala</a>
            </vs-td>
            <vs-td>
              <p class="product-name font-medium truncate">{{ tr.ProductTitle | title }}</p>
            </vs-td> 
            <vs-td>
              <vs-chip
                :color="getStatusColor(tr)"
                class="product-order-status"
              >{{ tr.IsActive && !tr.IsDeleted ? $t("Table.PaymentGroup.Status1") : $t("Table.PaymentGroup.Status2") }}</vs-chip>
            </vs-td>

            <vs-td class="whitespace-no-wrap">
              <feather-icon
                icon="EditIcon"
                svgClasses="w-5 h-5 hover:text-primary stroke-current"
                @click.stop="editData(tr)"
              />
              <feather-icon
                v-if="tr.IsActive && !tr.IsDeleted"
                icon="TrashIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="deleteData(tr.InvoiceSettingGroupID)"
              />
              <feather-icon
                v-if="tr.IsDeleted"
                icon="CheckIcon"
                svgClasses="w-5 h-5 hover:text-danger stroke-current"
                class="ml-2"
                @click.stop="updateData(tr.InvoiceSettingGroupID)"
              />
            </vs-td>
          </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import Vue from "vue";
import { AgGridVue } from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";

import CellRendererLink from "./cell-renderer/CellRendererLink.vue";
import CellRendererStatus from "./cell-renderer/CellRendererStatus.vue";
import CellRendererActions from "./cell-renderer/CellRendererActions.vue";
import CellRendererAccounts from "./cell-renderer/CellRendererAccounts.vue";

import StaffApi from "@/api/staff";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import VxAutoSuggest from "@/components/vx-auto-suggest/VxAutoSuggest.vue";
import DataViewSidebar from "./DataViewSidebar.vue";

Vue.directive("uppercase", {
  bind(el, _, vnode) {
    el.addEventListener("keyup", e => {
      e.target.value = e.target.value.toUpperCase();
      vnode.componentInstance.$emit("input", e.target.value.toUpperCase());
    });
  }
});

Vue.directive("uppercase-trim", {
  bind(el, _, vnode) {
    el.addEventListener("keyup", e => {
      e.target.value = e.target.value.toUpperCase();
      vnode.componentInstance.$emit(
        "input",
        e.target.value
          .toUpperCase()
          .trim()
          .split(" ")
          .join("")
      );
    });
  }
});

export default {
  components: {
    AgGridVue,
    vSelect,
    CellRendererLink,
    CellRendererAccounts,
    CellRendererStatus,
    CellRendererActions,
    ValidationProvider,
    ValidationObserver,
    VuePerfectScrollbar,
    VxAutoSuggest,
    DataViewSidebar
  },
  data() {
    return {
      addNewDataSidebar: false,
      sidebarData: {},
      deleteId: 0,
      updateId: 0,
      itemsPerPage: 4,
      productData: [],
      settings: {
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      navbarSearchAndPinList: {
        users: {
          key: "Name",
          data: []
        }
      },
      showFullSearch: false,
      syncNewBankPopup: false,
      formNewBank: {
        BankID: 0,
        BranchCode: "",
        BranchName: "",
        AccountOwner: "",
        AccountNumber: "",
        Iban: "",
        Swift: ""
      },
      searchQuery: "",
      // AgGrid
      gridApi: null,
      gridOptions: {},
      defaultColDef: {
        sortable: true,
        resizable: true,
        suppressMenu: true
      },
      columnDefs: [
        {
          headerName: this.$t("Table.PaymentGroup.ProductTitle"),
          field: "ProductTitle",
          filter: false
        },
        {
          headerName: this.$t("Table.PaymentGroup.ProductDesc"),
          field: "ProductDesc",
          filter: false
        },
        {
          headerName: this.$t("Table.PaymentGroup.ProductPrice"),
          field: "Price",
          filter: false,
          valueGetter: this.currencyFormat
        },
        {
          headerName: this.$t("Table.PaymentGroup.Notification"),
          filter: false,
          fullWidth: true,
          cellRendererFramework: "CellRendererAccounts"
        },
        {
          headerName: this.$t("Table.PaymentGroup.Actions"),
          pinned: "right",
          cellRendererFramework: "CellRendererActions"
        }
      ],

      components: {
        CellRendererStatus,
        CellRendererActions
      }
    };
  },
  watch: {},
  computed: {
    queriedItems() {
      return this.$refs.table
        ? this.$refs.table.queriedResults.length
        : this.products.length;
    },
    products() {
      return this.productData;
    },
    gridData() {
      return this.$store.getters["banks/getBankAccounts"];
    },
    paginationPageSize() {
      if (this.gridApi) return this.gridApi.paginationGetPageSize();
      else return 10;
    },
    totalPages() {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages();
      else return 0;
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx;
      }
      return 0;
    }
  },
  methods: {
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val;

      if (!val) {
        this.fetchLoadData();
      }
    },
    generateUrl(InvoiceSettingKey) {
      // return process.env.VUE_APP_BASE_URL + "paymentgroup/" + InvoiceSettingKey;
      return process.env.VUE_APP_BASE_URL + "payment";
    },
    onCopy() {
      this.$vs.notify({
        title: "Başarılı",
        text: "Link kopyalandı.",
        color: "success",
        iconPack: "feather",
        position: "top-center",
        icon: "icon-check-circle"
      });
    },
    getStatusColor(status) {
      if (status.IsActive && !status.IsDeleted == true) return "success";
      else return "danger";
    },
    addNewData() {
      this.sidebarData = {};
      this.toggleDataSidebar(true);
    },
    deleteData(id) {
      this.deleteId = id;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: "Dikkat",
        text:
          "İstenilen ürün kalıcı olarak silinecek. Devam etmek istiyor musunuz?",
        acceptText: "Sil",
        cancelText: "Vazgeç",
        accept: this.removeProduct
      });
    },
    updateData(id) {
      this.updateId = id;
      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: "Dikkat",
        text:
          "İstenilen ürün tekrar aktif hale getirilecek. Devam etmek istiyor musunuz?",
        acceptText: "Aktif Et",
        cancelText: "Vazgeç",
        accept: this.activeProduct
      });
    },
    editData(data) {
      this.sidebarData = data;
      this.toggleDataSidebar(true);
    },
    async removeProduct() {
      if (!this.deleteId) return;

      this.$vs.loading({
        color: "#000",
        scale: 0.45
      });

      let submitData = {
        InvoiceSettingGroupID: this.deleteId
      };

      let response = await StaffApi.removeSettingGroup(submitData, this);

      if (!response.data.error) {
        this.fetchLoadData();
      }

      this.deleteId = 0;
      setTimeout(() => {
        this.$vs.loading.close();
      }, 100);
    },
    async activeProduct() {
      if (!this.updateId) return;

      this.$vs.loading({
        color: "#000",
        scale: 0.45
      });

      let submitData = {
        InvoiceSettingGroupID: this.updateId
      };

      let response = await StaffApi.activeSettingGroup(submitData, this);

      if (!response.data.error) {
        this.fetchLoadData();
      }

      this.updateId = 0;
      setTimeout(() => {
        this.$vs.loading.close();
      }, 100);
    },
    currencyFormat(params) {
      return this.$options.filters.currency(params.data.Price);
    },
    showPersonList() {
      if (this.navbarSearchAndPinList.users.data.length > 0)
        this.showFullSearch = true;
    },
    hnd_search_query_update(query) {
      // Show overlay if any character is entered
      this.$store.commit("TOGGLE_CONTENT_OVERLAY", query ? true : false);
    },
    selected(item) {
      var id = item.users.Id;
      this.showFullSearch = false;
      if (id > 0) {
        this.$router.push({ name: "userview", params: { userId: id } });
      }
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridApi.sizeColumnsToFit();
      window.onresize = () => {
        this.gridApi.sizeColumnsToFit();
      };
    },
    getGridLocaleText(key, defaultValue) {
      var gridKey = "Grid_" + key;
      var value = this.$t(gridKey);
      return value === gridKey ? defaultValue : value;
    },
    setColumnFilter(column, val) {
      const filter = this.gridApi.getFilterInstance(column);
      let modelObj = null;

      if (val !== "all") {
        modelObj = { type: "equals", filter: val };
      }

      filter.setModel(modelObj);
      this.gridApi.onFilterChanged();
    },
    updateSearchQuery(val) {
      this.gridApi.setQuickFilter(val);
    },
    async fetchLoadData() {
      this.$vs.loading({
        color: "#000",
        scale: 0.45
      });

      let response = await StaffApi.getMyProducts(this);

      if (!response.data.error) {
        this.productData = response.data.model;
      }

      setTimeout(() => {
        this.$vs.loading.close();
      }, 100);
    }
  },
  beforeMount() {
    this.gridOptions.localeTextFunc = this.getGridLocaleText;
  },
  async mounted() {
    this.gridApi = this.gridOptions.api;

    if (this.$vs.rtl) {
      const header = this.$refs.agGridTable.$el.querySelector(
        ".ag-header-container"
      );
      header.style.left =
        "-" + String(Number(header.style.transform.slice(11, -3)) + 9) + "px";
    }

    await this.fetchLoadData();
  },
  created() {
    this.$store.commit("TOGGLE_CONTENT_OVERLAY", false);
  },
  beforeDestroy: function() {
    [...document.getElementsByClassName("con-vs-popup")].map(
      n => n && n.remove()
    );
    // this.$signalr.$off("checkSorryRentAreaAuth", this.checkSorryRentAreaAuth);

    if (this.checkDateTimer) clearInterval(this.checkDateTimer);

    this.$store.commit("TOGGLE_CONTENT_OVERLAY", false);
  }
};
</script>

<style lang="scss">
#payment-group-list {
  .vs-con-table {
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      // max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      // margin-left: 1.5rem;
      // margin-right: 1.5rem;
      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        td {
          padding: 20px;
          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }
          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }
        }
        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }
      th.td-check {
        padding: 0 15px !important;
      }
      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
